import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ServiceUsagePage } from '@/pages/admin/service-usage';
import { serviceUsageSearchSchema } from '@/routes/-shared/serviceUsageSearchSchema';

/**
 * La lista dei consumi per tenant resta montata e il dettaglio si apre sopra
 * di lei sull'`Outlet` (`$tenantId`): chiuderlo torna alla lista con tab e
 * ricerca di prima, e il link al tenant si può condividere.
 */
export const Route = createFileRoute('/admin/_layout/service-usage/_layout')({
  component: ServiceUsageLayout,
  validateSearch: serviceUsageSearchSchema,
});

function ServiceUsageLayout() {
  return (
    <>
      <ServiceUsagePage />
      <Outlet />
    </>
  );
}
